module.exports = __webpack_public_path__ + "img/public/SiteIcons/stepEditArrow.svg?0006e35d";